export default [
    // {
    //     path: '/route-module',
    //     name: 'name-route',
    //     component: () => import ('./views/ViewExample'),
    //     meta: {
    //         title: 'Título da rota',
    //         icon: 'mdi-file-document',
    //         breadcrumbs: [
    //             { text: 'Descrição da rota', disabled: true }
    //         ]
    //     }
    // },
]
